import React, { useRef, useEffect } from "react";
import classNames from "classnames";
import typographyStyles from "@campgladiator/cgui-core.atoms.typography/typography.module.scss";
import styles from "./textarea.module.scss";

export type TextAreaFieldProps = {
  disabled?: boolean;
  id: string;
  invalid?: boolean;
  name: string;
  onTextAreaChange?: (value: string) => void;
  size?: "default" | "small";
} & React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const textareaHeight = (self: HTMLTextAreaElement) => {
  self.style.height = "0px";
  self.style.height = self.scrollHeight + "px";
};

const TextArea = ({
  className = "",
  disabled = false,
  id,
  invalid = false,
  name,
  onTextAreaChange: onTextAreaChange,
  size = "default",
  value,
  ...props
}: TextAreaFieldProps) => {
  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  const handleOnChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    textareaHeight(textAreaRef.current as HTMLTextAreaElement);
    onTextAreaChange && onTextAreaChange(event.target.value);
  };

  useEffect(() => {
    value === "" &&
      textareaHeight(textAreaRef.current as HTMLTextAreaElement);
  }, [value]);

  return (
    <div
      className={classNames(className, styles.wrapper, {
        [styles.disabled]: disabled,
      })}
      data-invalid={invalid}
      data-input-size={size}
    >
      <textarea
        name={name}
        id={id}
        className={classNames(
          styles.textarea,
          typographyStyles.paragraph,
          className
        )}
        value={value}
        ref={textAreaRef}
        data-size={size}
        onChange={handleOnChange}
        disabled={disabled}
        {...props}
      />
    </div>
  );
};

export default TextArea;
